import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
// Import UI Components
import { Tooltip } from '@geneui/components';
// Import Styles
import styles from './dynamicRowList.module.scss';
// Import Types
import type { DynamicRowListProps } from './types';

const DynamicRowList: FC<DynamicRowListProps> = ({ columnsConfig, rows }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                {columnsConfig.map((columnData, index) => {
                    return (
                        <Tooltip text={t(columnData.columnLabel)} key={index}>
                            <div className={styles.headerItem} key={index}>
                                {t(columnData.columnLabel)}
                            </div>
                        </Tooltip>
                    );
                })}
            </div>
            <div className={styles.content}>
                {rows.map((row, index) => {
                    return (
                        <div className={styles.row} key={index}>
                            {columnsConfig.map((columnConfig, index) => {
                                return (
                                    <div className={styles.rowItem} key={index}>
                                        {row[columnConfig.columnName]}
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default memo(DynamicRowList);
